import { EPriceTabView } from "MVVM/@types";
import { TIER_PRICING } from "MVVM/Utilities/SubscriptionTiers";
import { experimentBucket } from "./experimentBucket";
import {
  isUnlimitedOnlyEligibleUser,
  TUnlimitedOnlyEligibilityUser,
} from "./unlimitedOnlyPaywall";

export const UNLIMITED_PRICE_EXPERIMENT = "unlimited_price_v1";
export type UnlimitedPriceVariant = "control" | "treatment";

// Account-based, independently salted 50/50 assignment survives devices and login.
export const unlimitedPriceVariant = (userId: string): UnlimitedPriceVariant =>
  experimentBucket(UNLIMITED_PRICE_EXPERIMENT, userId) < 0.5
    ? "control"
    : "treatment";

export const unlimitedPriceOffer = (variant: UnlimitedPriceVariant) => ({
  variant,
  pricing:
    variant === "treatment"
      ? {
          monthly: "$14.99",
          monthlyAnnual: "$179.88",
          annual: "$11.24",
          annualTotal: "$134.91",
          discount: "25%",
        }
      : TIER_PRICING.CREATOR_PLAT,
  stripeLookup: {
    [EPriceTabView.Monthly]: `${UNLIMITED_PRICE_EXPERIMENT}_${variant}_monthly`,
    [EPriceTabView.Annual]: `${UNLIMITED_PRICE_EXPERIMENT}_${variant}_yearly`,
  },
});

export const getUnlimitedPriceOffer = ({
  user,
  unlimitedOnly,
  provider,
  hasPromo,
  internal,
  enabled,
}: {
  user?: TUnlimitedOnlyEligibilityUser & {
    _id?: string;
    userGroup?: { hasUsedPlatinumTrial?: boolean; isTrialPeriod?: boolean };
  };
  unlimitedOnly: boolean;
  provider: string;
  hasPromo: boolean;
  internal: boolean;
  enabled: boolean;
}) => {
  if (
    !enabled ||
    !unlimitedOnly ||
    provider !== "stripe" ||
    hasPromo ||
    internal ||
    !user?._id ||
    !isUnlimitedOnlyEligibleUser(user) ||
    user.userGroup?.hasUsedPlatinumTrial ||
    user.userGroup?.isTrialPeriod
  )
    return null;
  // The price test is complete: new eligible accounts all receive the higher price.
  // Keep the original hash/offer helpers for historical cohort analysis only.
  return unlimitedPriceOffer("treatment");
};
